import { Stock } from "components/Stock/Stock.helper";
import { useMemo } from "react"
import { format } from 'date-fns';
import { ko } from 'date-fns/locale';
import { PrincipleHistoryType } from "./Principle.hooks"

type PrincipleHistoryItemProps = PrincipleHistoryType & {
  stock: Stock;
};

export const PrincipleHistoryItem = ({ stock, date, shares, currentPrice, stopLossPrice, takeProfitPrice }: PrincipleHistoryItemProps) => {
  const lossRate = useMemo(() => '-' + (((currentPrice - stopLossPrice) / currentPrice) * 100).toFixed(1) + '%', [currentPrice, stopLossPrice])
  const profitRate = useMemo(() => '+' + (((takeProfitPrice - currentPrice) / currentPrice) * 100).toFixed(1) + '%', [currentPrice, takeProfitPrice])
  const rate = useMemo(() => {
    if (!stock) return '';
    const calced = (((stock.regularMarketPrice - currentPrice) / currentPrice) * 100).toFixed(1);

    return Number(calced) > 0 ? `+${calced}%` : `${calced}%`;
  }, [currentPrice, stock])
  return (
    <div className="card">
      <div className="card-body">
        <h5 className="card-title">{stock?.krShortName}</h5>
        <h6 className="card-subtitle mb-2 text-muted">{format(new Date(date), 'Pp', { locale: ko })}</h6>
        <p className="card-text">
          <span>주식수</span>: {shares}<br />
          <span>현재가</span>: ${stock?.regularMarketPrice.toFixed(1)}({rate})<br />
          <span title="기록 당시 가격">기록가</span>: ${currentPrice.toFixed(1)}<br />
          <span>손절가</span>: ${stopLossPrice.toFixed(1)}{' '}({lossRate})<br />
          <span>익절가</span>: ${takeProfitPrice.toFixed(1)}{' '}({profitRate})
        </p>
      </div>
    </div>
  )
}
